import { PatientDto } from '../../../../services/forms-service/forms-service-types';

export const checkPatientData = (
    patient: PatientDto,
    publish: (event: any) => void,
    required: 'email' | 'phone' | 'both' | 'or' = 'both'
) => {
    const email = String(patient.email || '');
    const cellPhone = String(patient.cellPhone || '');
    const dateOfBirth = String(patient.dateOfBirth || '');

    if (
        !dateOfBirth ||
        (required === 'email' && !email) ||
        (required === 'phone' && !cellPhone) ||
        (required === 'both' && (!email || !cellPhone)) ||
        (required === 'or' && !email && !cellPhone)
    ) {
        publish({
            messageType: 'formsDialog',
            data: {
                type: `no-dob-or-email-or-sms`
            }
        });
        throw new Error(`Patient does not have ${required}, and date of birth`);
    }
};
